export const parseNumber = (value: string | number): number => {

    //If undefined, null or empty string, return 0
    if(value === undefined || value === null) return 0

    let parsedFloat: number
    if (typeof value === 'string') {

        //Remove everything that is NOT a number, our decimal separator (,) or a negative dash
        value = value.replaceAll(/[^\d,-]/g, '')
        if(value === '')
            return 0

        //replace decimalSeparator with a dot
        value = value.replace(',', '.')
        parsedFloat = parseFloat(value)
    } else {
        parsedFloat = value
    }

    let num: number = parseFloat(parsedFloat.toFixed(2))

    //Convert negative zero to zero
    if (Object.is(num, -0)) num = 0
    return num
}
